import { getOSByUserAgent } from "@toss/utils";

/* @toss/slash native functions and types */
export * from "@toss/react";
export * from "@toss/utils";
export * from "@toss/impression-area";
export * from "@toss/redirect";
export * from "es-hangul";

export const isAndroid = () => getOSByUserAgent() === "android";
export const isIOS = () => getOSByUserAgent() === "ios";
